import * as React from 'react'
import * as fs from './footer_m.module.scss'
import Logo from '@images/logo_white.png'
import LogoCircle from '@images/img_logo_cicle.png'
// import { Link } from 'gatsby'
const FooterM = () => {
  return null
}

export default FooterM